import { ReactNode } from "react";
import { TabsNavigation } from "@/shared/ui";
import { ColleaguesTabsEnum } from "@/domains/faction/constants/colleaguesTabsEnum";
import { HistoryTabsEnum } from "@/domains/faction/constants/historyTabsEnum";
import { factionsList } from "@/domains/faction/helpers/factionsList";

type Props = {
  title: string;
  Icon: (props: { className?: string }) => JSX.Element;
  tabs?: ColleaguesTabsEnum[] | HistoryTabsEnum[];
  activeTab?: ColleaguesTabsEnum | HistoryTabsEnum;
  setActiveTab?: (tab: ColleaguesTabsEnum | HistoryTabsEnum) => void;
  faction?: string;
  i18Path?: string;
  isNoTabs?: boolean;
  children?: ReactNode;
};

export default function FactionTabsRow({
  title,
  Icon,
  tabs,
  activeTab,
  setActiveTab,
  faction,
  i18Path,
  isNoTabs,
  children,
}: Props) {
  return (
    <div className="flex items-center mb-4">
      {Icon && <Icon className="size-4.5 font-bold/30" />}
      <p className="ml-2.5 text-14 font-bold leading-none uppercase">{title}</p>
      {children}
      {!isNoTabs && (
        <TabsNavigation
          tabs={tabs}
          selectedTab={activeTab}
          i18fileName="faction"
          i18Path={i18Path}
          onClick={setActiveTab}
          variant={2}
          color={factionsList[faction]?.colorAccent}
          className="ml-auto"
        />
      )}
    </div>
  );
}
